import styled from 'styled-components';

import { CommonFlex } from '../../styledComponents/common';

export const ScrollableContainer = styled.div`
  overflow-x: auto;
  overflow-y: visible;
  padding: 30px 0;
  position: relative;
  margin-top: -20px;
  margin-left: 30px;
`;

export const VerticalScale = styled.div`
  width: 30px;
  height: 25px;
  text-align: right;
`;

export const BarContainer = styled.div`
  height: 100%;
  position: relative;
`;

export const Bar = styled.div`
  width: 30px;
  background-color: ${({ bgColor }) => bgColor};
  position: relative;
  color: transparent;
  height: ${({ height }) => height};
`;

export const TooltipWrapper = styled.div`
  position: absolute;
  left: -30px;
  width: 200px;
  height: min-content;
  z-index: 1000;
`;

export const HorizontalScale = styled.div`
  width: ${({ width }) => width};
  border-bottom: 1px dotted grey;
  color: transparent;
  text-align: left;
  height: 25px;
  overflow: visible;
`;

export const AbsoluteScaleContainer = styled(CommonFlex)`
  position: absolute;
  top: -13px;
  left: 32px;
  z-index: 1;
  padding-top: 30px;
  text-align: start;
`;

export const CenteredText = styled(CommonFlex)`
  width: 100%;
  justify-content: center;
`;

export const LegendContainer = styled.div`
  display: flex;
  justify-content: center;
  gap: 20px;
  margin: 20px 0;
`;

export const LegendItem = styled.div`
  display: flex;
  align-items: center;
  gap: 5px;
`;

export const LegendColor = styled.div`
  width: 15px;
  height: 15px;
  background-color: ${({ color }) => color};
`;

export const LegendText = styled.span`
  font-size: 12px;
  color: #5e6c84;
`;

export const VerticalLabel = styled.div`
  position: absolute;
  transform: rotate(-90deg);
  transform-origin: left top;
  left: 10px;
  top: 400px;
  width: 200px;
  text-align: center;
  font-size: 15px;
  color: #5e6c84;
  margin-left: -10px;
`;
